export const loyaltyEndpoints = {

    getLoyaltyList: '/api/RedemptionItem/ListFilter',
    createVoucher: '/api/RedemptionItem/Insert',
    deleteVoucher: '/api/RedemptionItem/Delete',

    getRedeemStats: '/api/RedemptionHistory/GetRedemStatistics',

    getRedeemHistory: '/api/RedemptionHistory/Filter',


    getRedeemItemHistory:'/api/RedemptionHistory/FilterAll',

    redeemVoucher : '/api/RedemptionHistory/Redem',

    redeemApprove :'/api/RedemptionHistory/RedemApprove',

    redeemDeny: '',

    redeemConsume: '/api/RedemptionHistory/RedemConsume',

    photoInsert: '/api/Photo/Insert',

    updateLoyalty: '/api/RedemptionItem',

    updateVoucher: '/api/RedemptionItem/Update',

    updateRedemptionHistory: '/api/RedemptionHistory/Update'

};
